package br.com.texeratx.boardgametimeapp.data.repository

import br.com.texeratx.boardgametimeapp.core.network.ApiClient
import br.com.texeratx.boardgametimeapp.core.session.SessionManager
import br.com.texeratx.boardgametimeapp.data.model.game.CatalogGameDTO
import br.com.texeratx.boardgametimeapp.data.model.game.CreateGameRequest
import br.com.texeratx.boardgametimeapp.data.model.game.GameCategoryDTO
import br.com.texeratx.boardgametimeapp.data.model.game.GameDTO
import br.com.texeratx.boardgametimeapp.data.model.game.GameDetailDTO
import br.com.texeratx.boardgametimeapp.data.model.game.GameModeDTO
import br.com.texeratx.boardgametimeapp.data.model.game.UpdateGameRequest
import io.ktor.client.call.body

class GameRepository(
    private val api: ApiClient,
    private val sessionManager: SessionManager
) {

    suspend fun getGames(): Result<List<GameDTO>> {
        return try {
            sessionManager.load() ?: return Result.failure(Exception("Sessão expirada"))
            val response = api.get("games")
            Result.success(response.body())
        } catch (e: Exception) {
            Result.failure(e)
        }
    }

    suspend fun searchCatalog(
        query: String,
        limit: Int = 20,
        offset: Int = 0
    ): Result<List<CatalogGameDTO>> {
        return try {
            sessionManager.load() ?: return Result.failure(Exception("Sessão expirada"))
            val path = buildString {
                append("catalog/search?limit=$limit&offset=$offset")
                if (query.isNotBlank()) append("&q=$query")
            }
            val response = api.get(path)
            Result.success(response.body())
        } catch (e: Exception) {
            Result.failure(e)
        }
    }

    suspend fun getCatalogGame(catalogId: Long): Result<CatalogGameDTO> {
        return try {
            sessionManager.load() ?: return Result.failure(Exception("Sessão expirada"))
            val response = api.get("catalog/$catalogId")
            Result.success(response.body())
        } catch (e: Exception) {
            Result.failure(e)
        }
    }

    suspend fun getGameCategories(): Result<List<GameCategoryDTO>> {
        return try {
            sessionManager.load() ?: return Result.failure(Exception("Sessão expirada"))
            val response = api.get("game-categories")
            Result.success(response.body())
        } catch (e: Exception) {
            Result.failure(e)
        }
    }

    suspend fun getGameModes(): Result<List<GameModeDTO>> {
        return try {
            sessionManager.load() ?: return Result.failure(Exception("Sessão expirada"))
            val response = api.get("game-modes")
            Result.success(response.body())
        } catch (e: Exception) {
            Result.failure(e)
        }
    }

    suspend fun updateGame(
        gameId: Long,
        body: UpdateGameRequest
    ): Result<GameDTO> {
        return try {
            sessionManager.load() ?: return Result.failure(Exception("Sessão expirada"))
            val response = api.put("games/$gameId", body)
            Result.success(response.body())
        } catch (e: Exception) {
            Result.failure(e)
        }
    }

    suspend fun getGameById(gameId: Long): Result<GameDetailDTO> {
        return try {
            sessionManager.load() ?: return Result.failure(Exception("Sessão expirada"))
            val response = api.get("games/$gameId")
            Result.success(response.body())
        } catch (e: Exception) {
            Result.failure(e)
        }
    }

    suspend fun createGame(
        body: CreateGameRequest
    ): Result<GameDTO> {
        return try {
            sessionManager.load() ?: return Result.failure(Exception("Sessão expirada"))
            val response = api.post("games", body)
            Result.success(response.body())
        } catch (e: Exception) {
            Result.failure(e)
        }
    }

    suspend fun deleteGame(gameId: Long): Result<Unit> {
        return try {
            sessionManager.load() ?: return Result.failure(Exception("Sessão expirada"))
            api.delete("games/$gameId")
            Result.success(Unit)
        } catch (e: Exception) {
            Result.failure(e)
        }
    }
}
